export default __webpack_public_path__ + "static/media/copylink.cc7b9a30.svg";